import { useAppDispatch, useAppSelector, useHandlePageNavigate } from "./hooks";

import {
  pullVehicleReportAsync,
  selectVehicleReportStatus,
  selectAllReportNotesList,
} from "../features/reports/reportsSlice";

import { useLocation } from "react-router-dom";
import { PullVehicleReportParams } from "../features/reports/reportTypes";
import { useGetSpecificReportNotesDispatch } from "./notesHook";

import {
  setVehicleReportSearch,
  toggleReinitialize,
} from "../features/multisearch/multisearchSlice";
import { sendMemberEventAsync } from "../features/admin/adminSlice";

type UseAutoReportHook = () => (
  data: PullVehicleReportParams,
  pullLocation: string,
) => void;

/* Pull Vehicle Report */
const useVehicleReportDispatch: UseAutoReportHook = () => {
  const dispatch = useAppDispatch();
  const searchStatus = useAppSelector(selectVehicleReportStatus);
  const pageNavigate = useHandlePageNavigate();
  const location = useLocation();

  const allReportNotesList = useAppSelector(selectAllReportNotesList);
  const getSpecificReportNotes = useGetSpecificReportNotesDispatch();

  const pullVehicleReport = (
    data: PullVehicleReportParams,
    pullLocation: string,
  ) => {
    if (searchStatus === "loading") return;
    if (location.pathname !== "/vehicle-report") {
      pageNavigate("/vehicle-report");
    } else {
      window.scrollTo(0, 0);
    }

    dispatch(pullVehicleReportAsync(data))
      .unwrap()
      .then(result => {
        if (result.success) {
          dispatch(setVehicleReportSearch(data));
          dispatch(toggleReinitialize());
          if (
            data.vin &&
            allReportNotesList?.some(
              notes =>
                notes &&
                notes.reportType === "vehicle" &&
                notes.token === data.vin,
            )
          ) {
            getSpecificReportNotes({
              reportType: "auto",
              reportParams: {
                vin: data.vin,
              },
            });
          }
          dispatch(
            sendMemberEventAsync({
              EventAction: "Search",
              EventCategory: "Vehicle",
              MetaData: JSON.stringify({ "pull location": pullLocation }),
            }),
          );
        }
      })
      .catch(error => {
        console.log("Vehicle Report:", error.message);
        if (error.message !== "Not Found") {
          pageNavigate("/");
        }
      });
  };

  return pullVehicleReport;
};

export { useVehicleReportDispatch };
